export default __webpack_public_path__ + "static/media/ReMar-Badge.7d78d719.svg";